import { ThemeTagType } from "entities/themeTagTypes/types";
import { ChangeEvent, Dispatch, ReactNode, SetStateAction } from "react";
import { InputHookResult } from "shared/hooks/useInputState";
import { Translations } from "shared/types/languages";

export type TagDetailsType = {
  loading: boolean;
  submitting: boolean;
  isTagTypesLoading: boolean;
  tagId?: string;
  setTagId: Dispatch<SetStateAction<string | undefined>>;
  tagName?: InputHookResult;
  tagTypeInput?: InputHookResult;
  tagDescription?: InputHookResult;
  translations?: Translations;
  setTranslations: Dispatch<SetStateAction<Translations | undefined>>;
  errors: string;
  tagTypes?: ThemeTagType[];
  setErrors: Dispatch<SetStateAction<string>>;
  selectedTab: TagDetailsTabs;
  setSelectedTab: Dispatch<SetStateAction<TagDetailsTabs>>;
  onSubmitTag: () => void;
  onSubmitTagTranslation: () => void;
  onSubmitTagType: () => void;
  disabled: boolean;
  onChangeTagName: (e: ChangeEvent<HTMLInputElement>) => void;
  onCloseTagDetails: () => void;
  tagType: FormattedTagType | null;
  setTagType: Dispatch<SetStateAction<FormattedTagType | null>>;
};

export type TagDetailsProviderProps = {
  children: ReactNode;
};

export type FormattedTagType = {
  id: string;
  name: string;
};

export enum TagDetailsTabs {
  General,
  Translations,
}

export enum ManagedTranslations {
  TagName = "Tag name",
}